import { Component, computed, input, InputSignal, output, OutputEmitterRef, Signal } from '@angular/core';
import { ProductCollection } from '@cureskin/api-client/src/server-api';
import { CsIconModule } from "@components/icon";

@Component({
  selector: 'app-product-collection',
  imports: [CsIconModule],
  templateUrl: './product-collection.component.html',
  standalone: true
})
export class ProductCollectionComponent {
  collection: InputSignal<ProductCollection> = input<ProductCollection>();
  viewCollection: OutputEmitterRef<string> = output<string>();

  title: Signal<string> = computed(() => this.collection()?.title);
  name: Signal<string> = computed(() => this.collection()?.name);
  imageUrl: Signal<string> = computed(() => this.collection()?.imageUrl);
  description: Signal<string> = computed(() => this.collection()?.description);
}
